module.exports = __webpack_public_path__ + "img/42.d71112a4.png";